/* eslint-disable import/prefer-default-export */
import headers from "app/requests/headers";

export const get = (id) => (
  fetch(`/api/public/categories/${id}`, {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);
